import ActionButton from 'components/ActionButton';
import AddInventoryItemToRecipe from 'components/AddInventoryItemToRecipeModal';
import { Loading } from 'components/loading/Loading';
import React, { useEffect, useState } from 'react';
import { fetchAllInventoryItemsForRecipe } from 'services';
import { showError } from 'utils';
import styles from './index.module.scss';
import RecipeInventoryItemTable from './recipeInventoryItemTable';

const InventoryItemsForRecipe = props => {
  const [data, setData] = useState<string[]>([]);
  const [addInventoryItemModalOpen, setAddInventoryModalOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const { recipeId } = props;

  const fetchRecipeInventoryItems = async () => {
    setLoading(true);
    try {
      const response = await fetchAllInventoryItemsForRecipe(recipeId);
      setData(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecipeInventoryItems();
  }, []);

  return (
    <div className={styles['main-container']}>
      {addInventoryItemModalOpen && (
        <AddInventoryItemToRecipe
          recipeId={recipeId}
          onSuccess={fetchRecipeInventoryItems}
          toggleModal={() => setAddInventoryModalOpen(!addInventoryItemModalOpen)}
        />
      )}
      <div className={styles['section-header']}>
        <div className={styles['section-heading']}>Inventory Items</div>
        <ActionButton
          text={<>Inventory Item <span className={'ml-3'}>+</span></>}
          active={true}
          isLoading={false}
          onClick={() => { setAddInventoryModalOpen(true) }}
        />
      </div>
      {loading ? <Loading type={'mini'} /> : (
        <div>
          {!data && <div>No Inventory Items added</div>}
          <RecipeInventoryItemTable recipeId={recipeId} />
        </div>
      )}
    </div>
  );
};

export default InventoryItemsForRecipe;